import { useMutation } from '@tanstack/react-query';

import {
  getClassicSSOConfig,
  deleteClassicSSOConfig,
} from '../../../api/endpoints/support/classic-sso';
import { IErrorResponse } from '../../../api/interfaces';
import { IClassicSSO } from '../../../api/interfaces/support/classic-sso';

export const useGetClassicSSOConfig = () => {
  const {
    mutateAsync: getClassicSSO,
    isPending: isLoading,
    data: { config: ssoConfig } = {},
  } = useMutation<
    {
      [x: number]: string;
      config: IClassicSSO;
    },
    IErrorResponse,
    string
  >({
    mutationFn: (customerId) => getClassicSSOConfig(customerId),
  });

  return {
    getClassicSSO,
    ssoConfig,
    isLoading,
  };
};

export const useDeleteClassicSSOConfig = () => {
  const {
    mutateAsync: deleteClassicSSO,
    isPending: isLoading,
    data: { config: deletedConfig } = {},
  } = useMutation<
    {
      [x: number]: string;
      config: IClassicSSO;
    },
    IErrorResponse,
    { customerId: string }
  >({
    mutationFn: ({ customerId }) => deleteClassicSSOConfig(customerId),
  });

  return {
    deleteClassicSSO,
    deletedConfig,
    isLoading,
  };
};
